'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import { useOpenableControls } from '../../generic-hooks'
import { useGlobalConfigContext } from '../../global-config'
import { IconPrimaryArrow } from '../../icons'
import { urlResolverGetNewsletterSubscribeUnsubscribe } from '../../url-handling'

import { NewsletterExampleModal } from './NewsletterExampleModal'

export const NewsletterSubscribeDisclaimer: FC = () => {
  const globalConfig = useGlobalConfigContext()

  const modalControls = useOpenableControls()

  return (
    <div className="text-dark-primary-low">
      <div className="mb-7">
        <p className="mb-3">
          <FormattedMessage id="general.disclaimer.mandatory.fields" />
        </p>
        <p>
          <FormattedMessage id="general.disclaimer.voucher.conditions" />
        </p>
      </div>
      <div className="flex flex-col justify-between gap-5 tablet:flex-row">
        <Link
          className="flex cursor-pointer flex-nowrap items-center text-m font-bold no-underline"
          data-qa-id="form-newsletter-example"
          onClick={modalControls.handleOpen}
        >
          <FormattedMessage id="newsletter.page.example" />
          <IconPrimaryArrow className="size-5" />
        </Link>
        <Link
          className="flex flex-nowrap items-center text-m font-bold no-underline"
          data-qa-id="form-newsletter-unsubscribe"
          href={urlResolverGetNewsletterSubscribeUnsubscribe(globalConfig)}
        >
          <FormattedMessage id="newsletter.page.unsubscribe" />
          <IconPrimaryArrow className="size-5" />
        </Link>
      </div>
      <NewsletterExampleModal
        onClose={modalControls.handleClose}
        open={modalControls.isOpen}
      />
    </div>
  )
}
